var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Leaf',{staticClass:"banner-design-elements",staticStyle:{"right":"120px","top":"115px","opacity":"0.5"},attrs:{"width":"50px","fill":""}}),_c('Circles',{staticClass:"banner-design-elements",staticStyle:{"right":"-5px","top":"-10px","opacity":"0.4"},attrs:{"width":"300px","stroke":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }